import LinearProgress from '@mui/material/LinearProgress';
import React, {useContext, useEffect, useState} from "react";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import {useForm} from "react-hook-form";
import {Paper} from "@mui/material";
import { addOrganisationUserContractPart } from "../../../Services/HR/OrganisationUserContractPartService";
import OrganisationUserContractPartForm from "../../../Components/Forms/Pages/HR/OrganisationUserContractPart/OrganisationUserContractPartForm";
import { useSelector } from "react-redux";
import {getCurrentMonth, getCurrentYear} from "../../../Util/DateUtil";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'year': {required: true},
    'month': {required: true},
    'paymentDate': {required: true},
    'net': {required: true},
    'gross': {required: true},
    'paymentMonth': {required: true}
}

const AddOragnisationUserContractPart = (props) => {
    const siteData = useSelector((state) => state.siteData)
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: {
            paymentDate: null,
            net: props.organisationUserContract.net,
            gross: props.organisationUserContract.gross,
            year: getCurrentYear(),
            month: getCurrentMonth()
        }
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        setDrawerTitle(strings.pages.hr.organisationUserContractPart.addOrganisationUserContractPart.pageTitle);
    });

    const onSubmit = (data) => {
        setShowLoader(true);

        addOrganisationUserContractPart({
            ...data,
            currency: props.organisationUserContract.currency,
            organisationUserContract: props.organisationUserContract
        }).then(response => {
            setShowLoader(false);

            if (!response || !response.ok){
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        })
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress />
            }
            <OrganisationUserContractPartForm
                formRules={formRules}
                values={getValues()} setValue={setValue}
                data={data} errors={errors} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}
            />
        </Paper>
    </div>
}

export default AddOragnisationUserContractPart;